export default function Version() {
    return (
        <>
            v1.6.10
        </>
    )
}